import { useTranslation } from "react-i18next";

import { colors } from "@dotnet/telematics-design-system";

import { COMPANY_CARDS_LIMITS } from "../../../../../../../../Pages/Companies/types";
import { ROUTES, useMediaQueries } from "../../../../../../../../shared";
import BannerMessage, {
  BANNER_MESSAGE_STATUSES
} from "../../../../../../../BannerMessage/BannerMessage";
import Separator from "../../../../../../../Separator/Separator";
import useTutorialMode from "../../../../../../../TutorialMode/hooks/useTutorialMode";
import { DETAILS_TITLES, DetailsDataType } from "../../../../../../types";
import AccordionDetailsCard from "../../../AccordionDetailsCard/AccordionDetailsCard";
import AddCompanyCardButton from "../AddCompanyCardButton/AddCompanyCardButton";

interface NoCompanyCardsProps {
  currentCount: number;
  detailsData: DetailsDataType;
}

const NoCompanyCards = ({ currentCount, detailsData }: NoCompanyCardsProps) => {
  const { t } = useTranslation();
  const { isTutorialActive } = useTutorialMode();
  const { toMd } = useMediaQueries();

  return (
    <AccordionDetailsCard
      route={ROUTES.Companies}
      cardTitle={t(`Details##${DETAILS_TITLES.CompanyCards}`)}
      maxCount={COMPANY_CARDS_LIMITS.MaxResourceCount}
      currentCount={currentCount}
      quickTitleAction={
        <AddCompanyCardButton
          detailsData={detailsData}
          cardsCount={currentCount}
        />
      }
      customStyle={isTutorialActive && !toMd && { marginBottom: "80px" }}
    >
      <Separator color={colors.gray200} />
      <BannerMessage
        data-testid="no-company-cards-banner"
        status={BANNER_MESSAGE_STATUSES.Warning}
        title={t("Details##no company cards")}
        externalCustomStyle={{ margin: "16px" }}
      />
    </AccordionDetailsCard>
  );
};

export default NoCompanyCards;
